module.exports = __webpack_public_path__ + "static/media/presentation.3336bb13.pptx";